module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.notificationsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions,
      "hasRowDetails": false
    },
    on: {
      "rowSelected": _vm.onRowSelected
    },
    scopedSlots: _vm._u([{
      key: "validUntil",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.validUntil)))])]
      }
    }, {
      key: "created",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.created)))])]
      }
    }, {
      key: "priority",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.priority === _vm.Priority.LOW, 'btn-warning': props.row.priority === _vm.Priority.NORMAL, 'btn-danger': props.row.priority === _vm.Priority.HIGH
          }
        }, [_vm._v(_vm._s(_vm.$t('userAdministration.notificationPriorityStatus.' + props.row.priority)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.createNotificationModal",
      modifiers: {
        "createNotificationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.notificationCreate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "createNotificationModal",
      "title": _vm.$t('userAdministration.notificationCreate'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.createNotification
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.createNotification($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationPriority')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.notification.priority),
      callback: function($$v) {
        _vm.$set(_vm.notification, "priority", $$v)
      },
      expression: "notification.priority"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationValidUntil')
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true
    },
    model: {
      value: (_vm.notification.validUntil),
      callback: function($$v) {
        _vm.$set(_vm.notification, "validUntil", $$v)
      },
      expression: "notification.validUntil"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationText')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.text),
      expression: "notification.text"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "max-rows": "6",
      "name": "notification.text"
    },
    domProps: {
      "value": (_vm.notification.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "text", $event.target.value)
      }
    }
  })])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "reviewNotificationModal",
    attrs: {
      "id": "reviewNotificationModal",
      "title": _vm.$t('userAdministration.notificationEdit'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('userAdministration.userNotificationCancel'),
      "cancel-variant": "warning"
    },
    on: {
      "ok": function($event) {
        return _vm.updateNotification(false)
      },
      "cancel": function($event) {
        return _vm.updateNotification(true)
      }
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateNotification($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationPriority')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.selectedNotification.priority),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "priority", $$v)
      },
      expression: "selectedNotification.priority"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationValidUntil')
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true
    },
    model: {
      value: (_vm.selectedNotification.validUntil),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "validUntil", $$v)
      },
      expression: "selectedNotification.validUntil"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 5,
      "textarea": true
    },
    model: {
      value: (_vm.selectedNotification.text),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "text", $$v)
      },
      expression: "selectedNotification.text"
    }
  })], 1)], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02ad1aff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ad1aff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/user-administration/user-notification/user-notification.html
// module id = 767
// module chunks = 1